export default "__VITE_ASSET__BHhiP4QZ__"